import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { IonHeader, IonToolbar, IonTitle, IonButton, IonIcon, IonContent } from '@ionic/angular/standalone';
import { Environment, ENVIRONMENT } from "@qid/env";
import { SexyModule } from '@qid/sexy';
import { activeAccountChanges } from '../../../authentication';
import { ScannersFacade } from '../../+state/scanners.facade';
import { CollectionTemplate } from "../../../collection-template";
import { Scanner } from '../../models/scanner';
import { ViewScannerComponent } from '../../components/view-scanner/view-scanner.component';
import { AddTemplateOptionComponent } from '../../components/add-template-option/add-template-option.component';


@Component({
  selector: 'app-scanners',
  templateUrl: './scanners.page.html',
  styleUrls: ['./scanners.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    ViewScannerComponent,
    AddTemplateOptionComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonIcon,
    IonContent
  ]
})
export class ScannersPage implements OnInit {
  @Input() template: CollectionTemplate;
  @Input() baseUrl: string = this.environment.collectUrl;

  currentScanner: Scanner
  qrCode: string = null;
  slides = {
    viewForms: "viewTemplate",
    viewQr: "viewQr"
  }
  activeSlide = null;


  allScanners$ = this.scannerFacade.allRecords$

  private pageClosed$ = new Subject<void>();

  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private scannerFacade: ScannersFacade,
    private store: Store,
  ) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.pageClosed$ = new Subject<void>();
    activeAccountChanges(this.store)
      .pipe(takeUntil(this.pageClosed$))
      .subscribe(() => this.scannerFacade.init());
  }

  ionViewDidLeave() {
    this.pageClosed$.next();
    this.pageClosed$.complete();
  }



  selectedScanner(scanner: Scanner) {
    this.activeSlide = this.slides.viewQr;
    return this.currentScanner = scanner
  }

  close(ev: any) {
    if (ev === 1) {
      return this.activeSlide = null

    }
    this.activeSlide = null
  }

  getUniqueCode(code) {
    if (!code) {
      return
    }
    return code.toString().slice(-5)
  }

  generateVirtualQr = async () => {
    this.activeSlide = this.slides.viewForms;
    this.qrCode = new Date().getTime() + '' + (+(Math.random() * 10).toFixed(0) + 10);
  };


}
